angular
    .module('app')
    .component('subjectsEdit', {
        templateUrl: '/templates/pages/subjects/subjectsEdit/subjectsEdit.html',
        controller: 'SubjectsEditController',
        controllerAs: 'vm',
    });